/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Document } from './Document';
import {
    DocumentFromJSON,
    DocumentFromJSONTyped,
    DocumentToJSON,
} from './Document';

/**
 * 
 * @export
 * @interface CreateLeadRequest
 */
export interface CreateLeadRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateLeadRequest
     */
    source_id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadRequest
     */
    facility_id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadRequest
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadRequest
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadRequest
     */
    lead_received_date: string;
    /**
     * 
     * @type {Array<Document>}
     * @memberof CreateLeadRequest
     */
    documents?: Array<Document>;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadRequest
     */
    gender?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadRequest
     */
    dob?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadRequest
     */
    source_contact_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadRequest
     */
    source_discharge_date?: string | null;
}

/**
 * Check if a given object implements the CreateLeadRequest interface.
 */
export function instanceOfCreateLeadRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "source_id" in value;
    isInstance = isInstance && "facility_id" in value;
    isInstance = isInstance && "lead_received_date" in value;

    return isInstance;
}

export function CreateLeadRequestFromJSON(json: any): CreateLeadRequest {
    return CreateLeadRequestFromJSONTyped(json, false);
}

export function CreateLeadRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLeadRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'source_id': json['source_id'],
        'facility_id': json['facility_id'],
        'first_name': !exists(json, 'first_name') ? undefined : json['first_name'],
        'last_name': !exists(json, 'last_name') ? undefined : json['last_name'],
        'lead_received_date': json['lead_received_date'],
        'documents': !exists(json, 'documents') ? undefined : ((json['documents'] as Array<any>).map(DocumentFromJSON)),
        'gender': !exists(json, 'gender') ? undefined : json['gender'],
        'dob': !exists(json, 'dob') ? undefined : json['dob'],
        'source_contact_id': !exists(json, 'source_contact_id') ? undefined : json['source_contact_id'],
        'source_discharge_date': !exists(json, 'source_discharge_date') ? undefined : json['source_discharge_date'],
    };
}

export function CreateLeadRequestToJSON(value?: CreateLeadRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'source_id': value.source_id,
        'facility_id': value.facility_id,
        'first_name': value.first_name,
        'last_name': value.last_name,
        'lead_received_date': value.lead_received_date,
        'documents': value.documents === undefined ? undefined : ((value.documents as Array<any>).map(DocumentToJSON)),
        'gender': value.gender,
        'dob': value.dob,
        'source_contact_id': value.source_contact_id,
        'source_discharge_date': value.source_discharge_date,
    };
}

